import { useEffect, useState } from "react"
import { getSucursalById, postSucursal, patchSucursal} from "../../services/SucursalesServices"
import { SucursalesFormContext } from "./SucursalesContext"
import { useNavigate, useParams } from 'react-router-dom';

export const SucursalesFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getSucursalByIdData(id)
    }, [])

    const getSucursalByIdData = async (id) => {
        let res = await getSucursalById(id)
        if (res) setReport(res)
    }

    const postSucursalData = async (body) => {
        const res = await postSucursal(body)
        if (res) navigate("/sucursales");
    }

    const patchSucursalData = async (id, body) => {
        const res = await patchSucursal(id, body)
        if (res) navigate("/sucursales");
    }

    return <SucursalesFormContext.Provider value={{
        report,
        postSucursalData,
        patchSucursalData,
    }} >
        {children}
    </SucursalesFormContext.Provider>
}